import { render } from "./TrafficGroupMultiselect.vue?vue&type=template&id=65864f22&ts=true"
import script from "./TrafficGroupMultiselect.vue?vue&type=script&lang=ts"
export * from "./TrafficGroupMultiselect.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__